import { render } from "./NavCatHeader.vue?vue&type=template&id=30d45133&scoped=true"
import script from "./NavCatHeader.vue?vue&type=script&lang=js"
export * from "./NavCatHeader.vue?vue&type=script&lang=js"

import "./NavCatHeader.vue?vue&type=style&index=0&id=30d45133&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d45133"]])

export default __exports__